import crc32 from 'crc32';
import { useEffect, useMemo, useState } from 'react';

const getAnimationData = async (url) => {
	try {
		const hash = crc32(url);
		// Check if animation data already exists in browser storage
		const storageKey = `trial_animation_data_${hash}`;
		const storageItem = sessionStorage.getItem(storageKey);
		let animationData;

		if (storageItem) {
			animationData = storageItem;
		} else {
			const response = await fetch(url);
			const json = await response.json();
			if (json?.data) {
				animationData = json.data;
				try {
					sessionStorage.setItem(storageKey, animationData);
				} catch (e) {
					console.warn(e);
				}
			}
		}

		// Store animation data in component state
		if (animationData) {
			return JSON.parse(animationData);
		}
	} catch (e) {
		console.error(e);
	}
};

export const useDotLottie = ({ data, selection, step }) => {
	const { url, subtitle } = useMemo(() => {
		const currentGoal = data.options.find((option) => option.goal_id === selection[0].value);

		if (step === 0) {
			return { url: currentGoal.goal_animation, subtitle: currentGoal.goal_description };
		} else {
			const role = currentGoal.roles.find((role) => role.role_id === selection[step].value);
			return { url: role.role_animation, subtitle: role.role_description };
		}
	}, [selection, step]);

	const [animationData, setAnimationData] = useState();

	useEffect(() => {
		if (!url) {
			return;
		}
		(async () => {
			setAnimationData(await getAnimationData(url));
		})();
	}, [url]);

	return { animationData, subtitle };
};
